var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDxyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#06806B",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.98 43.1c2.32 0 4.38-.34 6.17-1.05C37.58 40.68 40 37.8 40 34.07v-.05c0-2.33-.83-4.15-2.35-5.48-1.5-1.32-3.78-2.3-6.82-2.93l-3.76-.78c-1.96-.43-4.5-1.25-4.5-3.63v-.04c0-1.45 1.08-2.48 2.37-2.98a7.9 7.9 0 0 1 2.93-.47c1.11 0 2.07.14 2.87.43 1.72.6 2.55 1.53 2.93 3.23h5.84c-.43-3.62-2.24-6.1-5.75-7.48a15.66 15.66 0 0 0-5.89-1.02c-2.24 0-4.22.36-5.94 1.08-3.23 1.35-5.47 4.16-5.47 7.69v.04c0 5.08 4.26 7.52 8.81 8.46l3.7.78c1.88.4 3.15.89 3.83 1.46.68.56 1.02 1.31 1.02 2.25v.04c0 1.55-1.02 2.62-2.42 3.15-.84.3-1.91.45-3.24.45a9.9 9.9 0 0 1-3.32-.47 4.73 4.73 0 0 1-2.04-1.32 3.65 3.65 0 0 1-.96-1.85H16a7.61 7.61 0 0 0 1.75 4.57 9.84 9.84 0 0 0 4.18 2.92c1.75.66 3.77.99 6.05.99ZM27 45h3V11h-3v34Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDxyLogo);
export default __webpack_public_path__ + "static/media/dxy-logo.1f5a2096f0c183cff8da1a1f644442dc.svg";
export { ForwardRef as ReactComponent };